import RouterErrorBox from "components/RouterErrorBox";
import type { NonIndexRouteObject } from "react-router-dom";

import TxRoute from "./TxRoute";

export const txRoute: NonIndexRouteObject = {
  element: <TxRoute />,
  errorElement: <RouterErrorBox />,
};
